'use client';

import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'src/redux';
import { 
  setCurrentFilterSetData as setCurrentFilterSetDataAction,
  clearCurrentFilterSetData as clearCurrentFilterSetDataAction,
  selectCurrentFilterSetData 
} from 'src/redux/slices/filterSelectionsSlice';

/**
 * Hook for managing edit drawer data state
 * Provides a clean abstraction for passing data between trigger components and edit drawers
 */
export const useEditDrawerData = () => {
  const dispatch = useAppDispatch();
  const currentFilterSetData = useAppSelector(selectCurrentFilterSetData);

  /**
   * Sets the current filter set data for editing
   * @param filterSet - The filter set data to set for editing
   */
  const setCurrentFilterSetData = useCallback(
    (filterSet: any) => {
      dispatch(setCurrentFilterSetDataAction(filterSet));
    },
    [dispatch]
  );

  /**
   * Gets the current filter set data being edited
   * @returns The current filter set data or null
   */
  const getCurrentFilterSetData = useCallback(() => {
    return currentFilterSetData;
  }, [currentFilterSetData]);

  /**
   * Clears the current filter set data
   * Should be called when closing edit drawers
   */
  const clearCurrentFilterSetData = useCallback(() => {
    dispatch(clearCurrentFilterSetDataAction());
  }, [dispatch]);

  return {
    getCurrentFilterSetData,
    setCurrentFilterSetData,
    clearCurrentFilterSetData,
    currentFilterSetData, // Direct access if needed
  };
};

export default useEditDrawerData;
